// extracted by mini-css-extract-plugin
export var inline = "_v5-0";